import React from "react";
import Apiconsole from "../apiconsole/apiconsole";
import Apikey from "../../../Component/ApiUser/apikey";
import Summary from "../../../Component/ApiUser/summary";

const Summarypage = () => {
  return (
    <Apiconsole>
      <Apikey role="user" choice={2}>
        <Summary />
      </Apikey>
    </Apiconsole>
  );
};

export default Summarypage;
